<template>
<div>
    <slot></slot>
</div>
</template>
<script>
export default {
    name:'page',
    props: {
        number:Number
    },
    updated () {
    },
    computed:{

    },
    methods:{

    },
}
</script>